import { UserService } from 'src/app/services/user/user.service';
import { DebugModeService } from 'src/app/services/general/debug-mode.service';
import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { StripeFactoryService, StripeInstance } from 'ngx-stripe';
import { User } from 'src/app/interfaces/user';

@Injectable({
  providedIn: 'root'
})
export class StripeSetupService implements OnInit, OnDestroy {

  constructor(
    private platform: Platform,
    private stripeFactory: StripeFactoryService,
    private userService: UserService,
    private debugModeService: DebugModeService,
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  setupStripe(currency?: string, debugMode?: boolean) {
    const stripeKey = this.getStripeKey(currency, debugMode);
    const stripe: StripeInstance = this.stripeFactory.create(stripeKey);
    return stripe;
  }

  getStripeKey(currency?: string, debugMode?: boolean) {
    if (!debugMode) {
      debugMode = this.debugModeService.debugMode;
    }
    if (debugMode) {
      if (currency === 'SGD') {
        return 'pk_test_51KEYlcBqit355hhKjqVUzNzkxS29qeVN6bn1NLo0DAy3kQaN5uCyGHfxme6Wq2Zo6wdeYOCDazKokwy7bezdR39R00rYyPsi8h';
      } else {
        return 'pk_test_51KF86dDkTCKjUS10SScDPvK6VBSUiDB7JPvPiAFJpO387PfyGy7gtFnNMYeNO2mGJQfWYFuIC5KAGxbXuy4qRGm7007NSw37DP';
      }
    } else {
      if (currency === 'SGD') {
        return 'pk_live_51KEYlcBqit355hhKV7psjR9eSzltEMEVei7HBX8z2qPuaw2OCFdr6Dn1QTJzyzFAoYDNChqZHBC8SfaPUlzdpwCY00tofWQydg';
      } else {
        return 'pk_live_51KF86dDkTCKjUS10IbQWbp4bi0BqAXJjb2wL61pSKmtc28YMSwM4w5zZOyMPNpMFzaUJZkBcnFPN5EjLRpJ8M0UD00kYrWYPtV';
      }
    }
  }

  /**
   * Get customer data
   * @returns customer data
   */
   getCustomerData() {
    const user: User = this.userService.user;
    const customer = {
      uid: user.uid,
      name: user.name,
      email: user?.email ? user.email : '',
      phone: user?.mobile?.no,
      stripe: user?.stripe?.length ? user.stripe : []
    };
    return customer;
  }
}
